
    import orig from "unextended!coffeescripts/registration/signupDialog.coffee";
    import p0 from "instructure_misc_plugin/app/coffeescripts/extensions/registration/signupDialog.coffee";

    export default p0(orig);
  